import GuestHeader from './Header';
import AuthHeader from './AuthHeader';
import AuthHeaderExt from './AuthHeaderExt'

export default {
    Guest: GuestHeader,
    Auth: AuthHeader,
    AuthExt: AuthHeaderExt
}